module.exports = __webpack_public_path__ + "static/media/star-shooting.0b04182c.svg";